import { render } from "./HelloWorld.vue?vue&type=template&id=ebfd2e9a"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=ebfd2e9a&lang=css"

import exportComponent from "/home/daniel/PhpstormProjects/kniffel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__